import { render, staticRenderFns } from "./add copy.vue?vue&type=template&id=41bf00ae&scoped=true"
import script from "./add copy.vue?vue&type=script&lang=js"
export * from "./add copy.vue?vue&type=script&lang=js"
import style0 from "./add copy.vue?vue&type=style&index=0&id=41bf00ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bf00ae",
  null
  
)

export default component.exports